import React, { useEffect } from 'react';
import Faqs from '../components/Faqs';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';

const Faq = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    return (
        <div className='overflow-x-hidden font-sans'>
            <Faqs />
            <Footer />
        </div>
    )
}

export default Faq